// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';



export class StateOnline implements flatbuffers.IUnpackableObject<StateOnlineT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):StateOnline {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsStateOnline(bb:flatbuffers.ByteBuffer, obj?:StateOnline):StateOnline {
  return (obj || new StateOnline()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsStateOnline(bb:flatbuffers.ByteBuffer, obj?:StateOnline):StateOnline {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new StateOnline()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

id():bigint {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : BigInt('-1');
}

dname():string|null
dname(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
dname(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

bio():string|null
bio(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
bio(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

passphrase():string|null
passphrase(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
passphrase(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

initialTime():number {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

extraTimePerTurn():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

maxTimePerTurn():number {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

static startStateOnline(builder:flatbuffers.Builder) {
  builder.startObject(7);
}

static addId(builder:flatbuffers.Builder, id:bigint) {
  builder.addFieldInt64(0, id, BigInt('-1'));
}

static addDname(builder:flatbuffers.Builder, dnameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, dnameOffset, 0);
}

static addBio(builder:flatbuffers.Builder, bioOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, bioOffset, 0);
}

static addPassphrase(builder:flatbuffers.Builder, passphraseOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, passphraseOffset, 0);
}

static addInitialTime(builder:flatbuffers.Builder, initialTime:number) {
  builder.addFieldInt32(4, initialTime, 0);
}

static addExtraTimePerTurn(builder:flatbuffers.Builder, extraTimePerTurn:number) {
  builder.addFieldInt32(5, extraTimePerTurn, 0);
}

static addMaxTimePerTurn(builder:flatbuffers.Builder, maxTimePerTurn:number) {
  builder.addFieldInt32(6, maxTimePerTurn, 0);
}

static endStateOnline(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createStateOnline(builder:flatbuffers.Builder, id:bigint, dnameOffset:flatbuffers.Offset, bioOffset:flatbuffers.Offset, passphraseOffset:flatbuffers.Offset, initialTime:number, extraTimePerTurn:number, maxTimePerTurn:number):flatbuffers.Offset {
  StateOnline.startStateOnline(builder);
  StateOnline.addId(builder, id);
  StateOnline.addDname(builder, dnameOffset);
  StateOnline.addBio(builder, bioOffset);
  StateOnline.addPassphrase(builder, passphraseOffset);
  StateOnline.addInitialTime(builder, initialTime);
  StateOnline.addExtraTimePerTurn(builder, extraTimePerTurn);
  StateOnline.addMaxTimePerTurn(builder, maxTimePerTurn);
  return StateOnline.endStateOnline(builder);
}

unpack(): StateOnlineT {
  return new StateOnlineT(
    this.id(),
    this.dname(),
    this.bio(),
    this.passphrase(),
    this.initialTime(),
    this.extraTimePerTurn(),
    this.maxTimePerTurn()
  );
}


unpackTo(_o: StateOnlineT): void {
  _o.id = this.id();
  _o.dname = this.dname();
  _o.bio = this.bio();
  _o.passphrase = this.passphrase();
  _o.initialTime = this.initialTime();
  _o.extraTimePerTurn = this.extraTimePerTurn();
  _o.maxTimePerTurn = this.maxTimePerTurn();
}
}

export class StateOnlineT implements flatbuffers.IGeneratedObject {
constructor(
  public id: bigint = BigInt('-1'),
  public dname: string|Uint8Array|null = null,
  public bio: string|Uint8Array|null = null,
  public passphrase: string|Uint8Array|null = null,
  public initialTime: number = 0,
  public extraTimePerTurn: number = 0,
  public maxTimePerTurn: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const dname = (this.dname !== null ? builder.createString(this.dname!) : 0);
  const bio = (this.bio !== null ? builder.createString(this.bio!) : 0);
  const passphrase = (this.passphrase !== null ? builder.createString(this.passphrase!) : 0);

  return StateOnline.createStateOnline(builder,
    this.id,
    dname,
    bio,
    passphrase,
    this.initialTime,
    this.extraTimePerTurn,
    this.maxTimePerTurn
  );
}
}
